/* @flow */
import React from 'react';
import Chip from 'material-ui/Chip';
import { graphql, createFragmentContainer } from 'react-relay';

import type { AcceptedJobOffer_offer } from './__generated__/AcceptedJobOffer_offer.graphql';

import TimeSlot from './TimeSlot';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
  left: {
    width: '50%',
  },
  right: {
    width: '50%',
  },
};

type Props = {
  offer: AcceptedJobOffer_offer,
};

const AcceptedJobOffer = ({ offer }: Props) => (
  <div style={styles.container}>
    <div style={styles.left}>
      <form>
        <h4>Time Slots</h4>
        {offer.sessions.map(({ timeSlot }) => (
          <div style={{ padding: 5 }} key={timeSlot.id}>
            <Chip>
              <TimeSlot timeSlot={timeSlot} />
            </Chip>
          </div>
        ))}
      </form>
    </div>
    <div style={styles.right}>
      <img alt="Tutor" width={100} src={offer.tutor.profilePictureUri} />
    </div>
  </div>
);

export default createFragmentContainer(AcceptedJobOffer, {
  offer: graphql`
    fragment AcceptedJobOffer_offer on JobOffer {
      tutor {
        fullname
        profilePictureUri
      }
      sessions {
        timeSlot {
          id
          ...TimeSlot_timeSlot
        }
      }
    }
  `,
});



// WEBPACK FOOTER //
// ./src/modules/job/components/AcceptedJobOffer.js